var Theme = Theme || {};

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })







/** Gestione cornici **/

// Funzione che sincronizza la selezione del valore "selectedValue" 
// all'interno di tutti i .RB_PC_Selector dentro .RB_Product_Card.
function syncRBPCSelect(selectedValue) {
  // Seleziona tutte le card presenti
  const productCards = document.querySelectorAll('.RB_Addon_Wrapper .RB_Product_Card');

  // Se non troviamo nessuna card, probabilmente la sezione non è ancora stata caricata.
  if (productCards.length === 0) {
    return false;
  }

  // Flag per capire se abbiamo trovato almeno una corrispondenza
  let foundMatch = false;

  productCards.forEach(card => {
    // Recupera la select
    const selector = card.querySelector('.RB_PC_Selector');
    if (!selector) return; // se non c'è nessuna select, passa oltre

    // Prova a trovare, tra le opzioni, quella con value == selectedValue
    const optionToSelect = Array.from(selector.options).find(opt => opt.value.trim() === selectedValue);

    if (optionToSelect) {
      // Imposta la select sul valore corrispondente
      selector.value = optionToSelect.value;
      selector.dispatchEvent(new Event('change', { bubbles: true }));

      foundMatch = true;
    }
  });

  // Se non abbiamo trovato corrispondenze in nessun select, logghiamo un avviso
  if (!foundMatch) {
    console.log("Nessuna corrispondenza trovata in .RB_Addon_Wrapper; nessuna modifica eseguita.");
  }

  // Se siamo arrivati qui, la sezione esiste, quindi restituiamo comunque true.
  return true;
}

// Attiva un MutationObserver per monitorare l'aggiunta della sezione o delle select
function attachMutationObserver(selectedValue) {
  const observer = new MutationObserver(function(mutations, obs) {
    // Ogni volta che ci sono modifiche nel DOM, riproviamo a sincronizzare
    if (syncRBPCSelect(selectedValue)) {
      // Se ora la sincronizzazione è andata a buon fine, interrompiamo l'osservazione
      obs.disconnect();
    }
  });
  // Osserviamo il body per modifiche (inclusi i nodi aggiunti in profondità)
  observer.observe(document.body, { childList: true, subtree: true });
}

// Listener per quando cambia la dimensione nei radio di .swatch-group 
document.addEventListener('change', function (event) {
  // Verifica che l'evento provenga da un input radio all'interno di .swatch-group
  if (event.target.matches('.swatch-group input[type="radio"]')) {
    const selectedValue = event.target.value.trim();
    console.log("Dimensione selezionata:", selectedValue);

    // Tenta la sincronizzazione
    if (!syncRBPCSelect(selectedValue)) {
      // Se la sezione non è ancora presente, attiva un MutationObserver
      attachMutationObserver(selectedValue);
    }
  }
});

// All'avvio della pagina, controlliamo se ci sono radio già selezionati
document.addEventListener('DOMContentLoaded', function() {
  const checkedRadio = document.querySelector('.swatch-group input[type="radio"]:checked');
  if (checkedRadio) {
    const selectedValue = checkedRadio.value.trim();
    console.log("Dimensione selezionata (load):", selectedValue);

    if (!syncRBPCSelect(selectedValue)) {
      attachMutationObserver(selectedValue);
    }
  }

});


/*
// Funzione che aggiunge il listener di click
// a tutti i .RB_Product_List presenti nel DOM.
function attachMediaClickHandler() {
  const productLists = document.querySelectorAll('.RB_Product_List');
  
  // Se non troviamo alcun elemento .RB_Product_List,
  // restituiamo false perché potrebbe significare
  // che non è ancora stata caricata la sezione nel DOM.
  if (productLists.length === 0) {
    return false;
  }

  productLists.forEach(list => {
    // Per evitare di attaccare più volte l'handler
    // allo stesso elemento, usiamo un attributo custom.
    if (!list.hasAttribute('data-handler-attached')) {
      list.addEventListener('click', (e) => {

        const thisCard = list.querySelector('.RB_Product_Card');
        //if (!thisCard) return;

        console.log('list');
        //const selectedCards = document.querySelectorAll('.RB_Product_Card[data-status="true"]');
    //     selectedCards.forEach(card => {
      //     if (card !== thisCard) {
       //      const mediaElement = card.querySelector('.RB_PC_Media');
        //     console.log(mediaElement);
         //    if (mediaElement) {
          //     mediaElement.click();
         //    }
            
           
          }
   //     });
        
        
        // Al click sul container, triggeriamo il click
        // sul suo figlio .RB_PC_Media (se presente).
        const mediaElement = list.querySelector('.RB_PC_Media');
        if (mediaElement) {
          mediaElement.click();
        }
      });

      // Segniamo che abbiamo già aggiunto il listener
      list.setAttribute('data-handler-attached', 'true');
    }
  });

  // Se siamo arrivati qui significa che abbiamo trovato
  // almeno un .RB_Product_List. Restituiamo true.
  return true;
}

// Funzione che crea il MutationObserver e
// osserva il body per modifiche nel subtree.
function attachMutationObserverForMediaClick() {
  const observer = new MutationObserver((mutations, obs) => {
    // Ogni volta che il DOM cambia, riproviamo
    // ad agganciare il listener.
    if (attachMediaClickHandler()) {
      // Se finalmente riusciamo ad agganciare i listener,
      // possiamo scollegare l’osservazione (se desiderato).
      obs.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Avviamo tutto quando il DOM è carico.
document.addEventListener('DOMContentLoaded', function() {
    // Controllo preliminare: se non esiste .wcpb_ao_section nel DOM, esco
  const wcpbSection = document.querySelector('.wcpb_ao_section');
  if (!wcpbSection) {
    return;
  }
  
  // Se attachMediaClickHandler non trova
  // nessun .RB_Product_List, allora avviamo
  // il MutationObserver.
  if (!attachMediaClickHandler()) {
    attachMutationObserverForMediaClick();
  }
});
*/

